<script>
    import Webinar from '$lib/components/_DisplayComponents/Webinar/Webinar.svelte';

    import { getColor, getColorByLightness, getCookiePreferences } from '$lib/helper';
    import MediaOverlay from '../../ConsentOverlay/MediaOverlay/MediaOverlay.svelte';
    import { trackButtonClick } from '$lib/global/tracking/v3';
    import get from 'lodash/get';
    import { mediaCookiesAccepted } from '$lib/Stores/stores';
    import { NextPageNavigator } from '$lib/global/helper/NextPageNavigator';
    import { page } from '$app/stores';

    export let id = '';
    export let theme = {};
    export let content = {};
    export let campaignId = '';
    export let cookiesEnabled = false;
    export let nextPage = '';
    export let firstResultPage = '';
    export let transitionDelay = 0;
    export let transitionEffect = 'none';
    export let language = 'de';

    const {
        data: { pageIdSlugMap },
    } = $page;

    // Navigation
    const externalLink = content.linking.url;
    const nextPageNavigator = new NextPageNavigator(campaignId, firstResultPage, pageIdSlugMap);
    const regularNextPage = get(content, 'linking.pageId', nextPage);
    const isExternal = !content.linking.isInternal && !!externalLink;

    const cookies = getCookiePreferences(campaignId);

    const btnBgColor = getColor(content.backgroundColor, theme.buttonBackgroundColor);
    const btnColor = getColor(get(content, 'color'), getColorByLightness(btnBgColor));

    const handleBtnClick = () => {
        // Tracking
        trackButtonClick(id);

        // Navigate to external page
        if (isExternal) {
            return nextPageNavigator.goExternal(externalLink);
        }

        return nextPageNavigator.go(regularNextPage);
    };

    const handleBtnMouseEnter = () => {
        nextPageNavigator.preload(regularNextPage, isExternal);
    };

    $: acceptedMediaOverlay = cookies.Media || $mediaCookiesAccepted;
</script>

{#if cookiesEnabled && !acceptedMediaOverlay}
    <MediaOverlay {campaignId} {language} />
{:else}
    <svelte:component
        this={Webinar}
        url={content.video}
        durationTrigger={content.duration}
        message={content.placeholderText}
        btnText={content.text}
        onBtnClick={handleBtnClick}
        onBtnMouseEnter={handleBtnMouseEnter}
        box={content.box}
        {btnBgColor}
        {btnColor}
        {transitionDelay}
        {transitionEffect}
    />
{/if}
